import { render, staticRenderFns } from "./OrderHistoryView.vue?vue&type=template&id=0e8337e3&"
import script from "./OrderHistoryView.vue?vue&type=script&lang=ts&"
export * from "./OrderHistoryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrderHistoryView.vue"
export default component.exports